/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { usePrepareChartConfig, useChartGlobals, useCreateChart, useChartUpdates, useCanvasCtx } from './utils';
import { ChartLayout } from '../ChartLayout';
import { jsx as _jsx } from "react/jsx-runtime";
export var ChartFactory = function ChartFactory(props) {
  var chartCfgParams = props.chartCfgParams,
    chartHeight = props.chartHeight,
    datasetCfgCreators = props.datasetCfgCreators,
    directChartCfg = props.directChartCfg;
  var _useCanvasCtx = useCanvasCtx(),
    chartCtx = _useCanvasCtx.chartCtx,
    chartCanvasRef = _useCanvasCtx.chartCanvasRef;
  useChartGlobals();
  var chartConfig = usePrepareChartConfig(chartCtx, {
    chartCfgParams: chartCfgParams,
    chartHeight: chartHeight,
    datasetCfgCreators: datasetCfgCreators,
    directChartCfg: directChartCfg
  });
  var chart = useCreateChart(chartCtx, chartConfig);
  useChartUpdates(chart, chartConfig);
  return /*#__PURE__*/_jsx(ChartLayout, {
    chartCanvasRef: chartCanvasRef,
    chartHeight: chartHeight,
    className: props.className,
    style: props.style
  });
};
ChartFactory.displayName = 'ChartFactory';